import React from "react";

const CircularSectorProgress = ({
  size = 40,
  progress = 25, // percentage (0–100)
  color = "currentColor",
  background = "none",
  strokeColor = "currentColor",
  strokeWidth = 2,
}) => {
  const radius = size / 2;
  const angle = (progress / 100) * 360;
  const radians = (angle - 90) * (Math.PI / 180);
  const x = radius + radius * Math.cos(radians);
  const y = radius + radius * Math.sin(radians);
  const largeArc = angle > 180 ? 1 : 0;
  const innerRadius = radius - strokeWidth / 2;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {/* Outer circle */}
      <circle
        cx={radius}
        cy={radius}
        r={innerRadius}
        fill={background}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Filled sector */}
      {progress >= 100 ? (
        // Full circle fill when progress is 100%
        <circle cx={radius} cy={radius} r={innerRadius} fill={color} />
      ) : progress > 0 ? (
        <path
          d={`M${radius},${radius} L${radius},0 A${radius},${radius} 0 ${largeArc} 1 ${x},${y} Z`}
          fill={color}
        />
      ) : null}
    </svg>
  );
};

export default CircularSectorProgress;
